import { useCallback, useState } from 'react';
import { SwitchContainer, Slider, Input } from './Switch.styled';

import type { FC } from 'react';
import type { Color } from 'styled/types';

interface SwitchProps {
  checked?: boolean;
  disabled?: boolean;
  color?: Color;
  onClick?: () => void;
}

export const Switch: FC<SwitchProps> = ({
  checked = false,
  color = 'primary',
  disabled = false,
  onClick,
}) => {
  const [toggle, setToggle] = useState(checked);

  const handleSlider = useCallback(() => {
    setToggle(!toggle);
    if (typeof onClick === 'function') onClick();
  }, [onClick, toggle]);

  return (
    <SwitchContainer color={color} toggle={toggle} disabled={disabled}>
      <Input type="checkbox" defaultChecked={toggle} />
      <Slider onClick={handleSlider} />
    </SwitchContainer>
  );
};
